import axios from "axios";
import API from "../helpers/api";
import { getReportlist, exportReportPDF } from "../Actions/ReportsAPI";
const constSearchData = {
   
  vesselname: "",
  minyear: "",
  maxyear: "",
  pagesize: 10,
  pagenumber: 1,
};
export const getShipnameList = () => {
  // let url = `${API.shipNames}?ClientMail=${item}`;
  let url = `${API.shipNames}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if(response.status===200){
          dispatch({
            type: "getshipListSuccess",
            data: response.data,
          });
         
        }
     
      })
      .catch((error) => {
        dispatch({
          type: "getshipListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCompanynameList = () => {
  let url = `${API.companyNames}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCompanyListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCompanyListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCompanySpecialList = () => {
  let url = `${API.SpecialClientList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getSpecialCompanyListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getSpecialCompanyListSuccessFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCompanyUsersList = (name) => {
  let url = `${API.companyUserNames}?clientName=${btoa(name)}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCompanyUsersListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCompanyUsersListFailure",
          error: "ERROR",
        });
      });
  };
};
